export const itemContainer = {
    paddingTop: "30px"
};

export const shopClosedSign = {
    textAlign: "center",
    fontWeight: "bold"
};

export const link = {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center"
};

//MOBILE
export const mobile_productRow = {
    display: "flex",
    flexDirection: "row"
};
export const mobile_productContainer = {
    // border: "1px solid black",
    width: "50%",
    padding: "5px"
};

export const mobile_policyContainer = {
    textAlign: "center"
};
